export class HashtagDashboardItem {
  constructor (raw) {
    this.id = raw.id
    this.name = raw.name
    this.label = raw.label || raw.name
    this.color = raw.color || '#4299e1'
    this.totalOccurrences = raw.total_occurrences || 0
    this.trend = raw.trend || []
  }

  get trendData () {
    return this.trend.map(t => t.occurrences)
  }

  get trendCategories () {
    return this.trend.map(t => t.day)
  }

  get hasTrend () {
    return this.trend.length > 0
  }
}

export default class HashtagDashboard {
  constructor (raw) {
    this.startDate = raw.start_date
    this.endDate = raw.end_date
    this.hashtags = (raw.hashtags || []).map(h => new HashtagDashboardItem(h))
  }

  get hasData () {
    return this.hashtags.some(h => h.totalOccurrences > 0)
  }

  get activeHashtags () {
    return this.hashtags.filter(h => h.totalOccurrences > 0)
  }
}



// WEBPACK FOOTER //
// ./src/app/news_feed/models/HashtagDashboard.js